// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__J4Y9L","top":"styles_top__1DjX-"};